import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ControlShowcase from './components/ControlShowcase';
import InfiniteMarquee from './components/InfiniteMarquee';
import LifecycleVideo from './components/LifecycleVideo';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-[#0D0D0D] selection:bg-[#D4AF37] selection:text-black">
      <Header />
      <Hero />
      <ControlShowcase />
      <InfiniteMarquee />
      <LifecycleVideo />
      <Footer />
    </div>
  );
}

export default App;